module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ded"
    }
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pv"
    }
  }), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THIS")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BOOK")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("IS")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("DEDICATED")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("TO")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("JOHN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("TRYNESKI,")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("EXECUTIVE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("EDITOR")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AT")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("UNIVERSITY")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CHICAGO")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("PRESS,")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("WHO")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("HAS")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("DEVOTED")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("HIS")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CAREER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("TO")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CONVERTING")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("WORDS,")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("IDEAS,")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("RESEARCH")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("SCHOLARS")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("INTO")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("KNOWLEDGE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("IMPORTANCE.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35c00d06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-druckman-jacobs-0006.vue
// module id = 69
// module chunks = 0